import React from "react";
import connect from "react-redux/es/connect/connect";
import isEqual from "lodash-es/isEqual";
import Target from "./Target";

export class TillBasedTarget extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        const {props} = {...this.props};
        if (!isEqual(prevProps.till, this.props.till) || !isEqual((props.getValue("target") || {}).id, (((this.props.till|| {}).pos || {}).location || {}).id)) {
            props.setFieldValue && props.setFieldValue("target", ((this.props.till|| {}).pos || {}).location || null);
        }
    }

    getProps = (name) => {
        const {props} = {...this.props};
        const fieldProps = props.getProps(name);
        fieldProps.disabled = true;
        return fieldProps;
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels, pool, operationitems} = props;
        return (hidden || []).indexOf("target") === -1 && <Target
            {...{...propsTop, props: {...propsTop.props, getProps: this.getProps}}} />;
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(TillBasedTarget);